import { render, staticRenderFns } from "./newarrival.vue?vue&type=template&id=b5ad6af0&"
import script from "./newarrival.vue?vue&type=script&lang=js&"
export * from "./newarrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports